export default __webpack_public_path__ + "static/media/payment.69f190a0.svg";